import { render, staticRenderFns } from "./InventarioAnualList.vue?vue&type=template&id=3487ad98&scoped=true"
import script from "./InventarioAnualList.vue?vue&type=script&lang=js"
export * from "./InventarioAnualList.vue?vue&type=script&lang=js"
import style0 from "./InventarioAnualList.vue?vue&type=style&index=0&id=3487ad98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3487ad98",
  null
  
)

export default component.exports